module.exports = __webpack_public_path__ + "img/11.82becc9c.jpg";